import React from 'react';
import './Loading.css';

function Loading({text, loading}) {
  return (
    <div className={`loading-overlay${!loading ? ' fade-out' : ''}`}>
      <div className="loading-content">
        <div className="loading-text">
          <img src="/images/find-grumple-loading-text.png" alt="Finding where to buy Grumple" className="loading-image-text" />
        </div>
        <div className="loading-spinner"></div>
        <img src="/images/find-grumple-loading.png" alt="Grumple" className="loading-image" />
      </div>
    </div>
  );
}

export default Loading;




// WEBPACK FOOTER //
// ./src/pages/findGrumple/components/Loading.js